import MuiDialogContent from '@mui/material/DialogContent';
import {
  type ComponentPropsWithoutRef,
  type ComponentRef,
  forwardRef,
} from 'react';

type DialogContentProps = ComponentPropsWithoutRef<typeof MuiDialogContent>;
type DialogContentRef = ComponentRef<typeof MuiDialogContent>;

const DialogContent = forwardRef<DialogContentRef, DialogContentProps>(
  (props, ref) => {
    return <MuiDialogContent ref={ref} {...props} />;
  },
);
DialogContent.displayName = 'DialogContent';
export default DialogContent;
